/**
 * @GENERATED from Figma node 3608:51045
 */

import * as React from "react";
export type IconProps = Omit<React.SVGProps<SVGSVGElement>, "color">;
const SalesforceDark = (props: IconProps, ref: React.Ref<SVGSVGElement>) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    fill="none"
    viewBox="0 0 24 24"
    focusable={false}
    role="presentation"
    ref={ref}
    {...props}
  >
    <path
      fill="#00A1E0"
      fillRule="evenodd"
      d="M13.436 17.683a4.002 4.002 0 0 0 5.438-2.684L19 15a5 5 0 1 0-2.675-9.225A4 4 0 0 0 13 4a3.99 3.99 0 0 0-2.716 1.063A4.5 4.5 0 0 0 2.39 9.336a4 4 0 0 0 2.805 7.482 4.502 4.502 0 0 0 8.24.865"
      clipRule="evenodd"
    />
  </svg>
);
const ForwardRef = React.forwardRef(SalesforceDark);
export { ForwardRef as SalesforceDark };
